export default "__VITE_ASSET__f08bc409__"